import { TimeCard } from '../../../Common/Charts/TimeCard/TimeCard';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';

export const CallsTimes = () => {
    const { chartData } = useServicesChartsDataContext();
    const times = chartData?.callsTimes;

    return (
        <div className="charts-side-by-side-dashboards">
            <TimeCard title="Chamado - Tempo Mínimo" value={times?.minTime} />
            <TimeCard title="Chamado - Tempo Médio" value={times?.avgTime} />
            <TimeCard title="Chamado - Tempo Máximo" value={times?.maxTime} />
        </div>
    );
};
